import BaseClient from '@/app/model/api/response/baseApiClient'

class GetNewsBoardFileApi extends BaseClient {
  public getNewsBoardFile (id: number) {
    const path = '/v1/file/news-board/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }

  public getNewsBoardFileBlob (id: number) {
    const path = '/v1/file/news-board/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    const body: any = this.buildRequestBodyIfNeeded('GET')
    return fetch(decodeURI(url.href), body)
      .then(response => this.doResponseConvert(response))
      .catch(e => this.doError(e))
  }

  public doResponseConvert (response: any) {
    if (response.status === 200) {
      return response.blob()
    } else {
      throw Error(response.status)
    }
  }

  public getPayload (data: any) {
    const outside: any = URL.createObjectURL(data)
    return outside
  }
}

export default new GetNewsBoardFileApi()
